import { FlexBox, Link, Typography } from "@vp/swan";
import React from "react";
import { PageContext } from "../../types/Global";
import DebugInfoUtil from "./DebugInfoUtil";

export interface DebugPageInfoProps {
  pageContext: PageContext;
}

export const DebugPageInfo = (props: DebugPageInfoProps) => {
  const pageContentfulLink = DebugInfoUtil.generateContentfulEntryLink(
    props.pageContext.spaceId,
    props.pageContext.pageId
  );

  return (
    <FlexBox flexDirection="column" mr={"6"}>
      <FlexBox flexDirection="row" alignItems="center">
        <Typography mb={"2"} mr={"4"} fontWeight="bold">
          Page Information
        </Typography>
        <Link href={pageContentfulLink} target="_blank">
          <Typography fontSize={"small"}>Contentful</Typography>
        </Link>
      </FlexBox>
    </FlexBox>
  );
};
